<script lang="ts" setup>
import { computed } from 'vue';
import { px2rem } from '@pet/core.mobile';
interface Props {
    /**
     * 自定义样式
     */
    customClsName?: string;
    /**
     * 图标地址
     */
    iconUrl?: string;
    /**
     * 销量进度的文案
     */
    textList?: string;
    /**
     * 进度条渐变色
     */
    linearGradientColor?: string;
    /**
     * 秒杀进度的背景色
     */
    backgroundColor?: string;
    /**
     * 秒杀进度比
     */
    sellPercent?: number;
}

const props = withDefaults(defineProps<Props>(), {
    customClsName: '',
    usedNum: 0,
    sellPercent: 0,
    backgroundColor: 'linear-gradient(270deg, #FFDEEE 0%, #FFE3E9 100%)',
    iconUrl: '',
    linearGradientColor: '#FFF0F4',
});

// const sellPercent = computed(() => {
//     return Math.min(props.usedNum ?? 0 / (props.totalNum ?? 1), 1);
// });

// const percentWidth = computed(() => {
//     return Math.max(sellPercent.value * props.processWidth ?? 0, 35);
// });

const showProgress = computed(() => {
    return props.sellPercent !== 0;
});

const percentWidth = computed(() => {
    return `${props.sellPercent * 100}% `;
});
</script>

<template>
    <div class="seckill">
        <div class="seckill-main" :style="{ background: linearGradientColor }">
            <div
                v-if="showProgress"
                class="seckill-main-progressPop"
                :style="{ width: percentWidth, background: backgroundColor }"
            >
                <div class="seckill-main-progressPop-progressPopText">
                    {{ textList }}
                    <img v-if="iconUrl" :src="iconUrl" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
$progress-bar-height=12px
$progress-bar-width=128px
.seckill
    &-main
        background-color #FFF0F4
        border-radius 8px
        line-height 15px
        position relative
        height $progress-bar-height
        width $progress-bar-width

        &-progressText
            font-size 10px
            color: #fe3666
            line-height: 10px
            font-weight: 400
            position: relative
            left: -8px

        &-progressPop
            position: absolute
            left: 0
            color: #fff
            top: 0
            border-radius: 8px
            height $progress-bar-height
            padding: 0 2px
            display: flex
            justify-content: space-between
            align-items: center

            &-progressPopText
                white-space: nowrap
                color #FE3666
                font-family: PingFang SC;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: 10px; /* 100% */
                position relative
                left 8px

            img
                width: 16px
                transform: scale(1.5)
                height: 16px
                position: relative
                top: -4px
                right: -6px
                margin-left: -6px
</style>
